import { memoirsApiInstance } from "./api";

// ElevenLabs is only reached through the backend, which keeps the API key.

export type PresetVoice = {
  voice_id: string;
  name: string;
  preview_url: string | null;
};

export type ClonedVoice = {
  voice_id: string;
  name: string;
};

export const fetchPresetVoices = () =>
  memoirsApiInstance.get<PresetVoice[]>("/voices");

export const cloneVoice = (files: File[]) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files[]", file));
  return memoirsApiInstance.post<ClonedVoice>("/voices", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const previewVoice = (voiceId: string, text: string) =>
  memoirsApiInstance.post<Blob>(
    `/voices/${encodeURIComponent(voiceId)}/preview`,
    { text },
    { responseType: "blob" }
  );
